export const getMemberImageUrl = (skinImageUrl: string) =>
  skinImageUrl ? `${skinImageUrl}?${Date.now()}` : skinImageUrl;
